import {Button, Divider, Flex, Input, Modal} from "antd";
import React, {useEffect} from "react";
import {Link, useNavigate} from "react-router-dom";
import Password from "antd/es/input/Password";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {fetchUser, signin} from "../../feature/project/userSlice";
import md5 from "md5";
import {resetProject} from "../../feature/project/projectsSlice";
import {useCookies} from "react-cookie";

export const Login = () => {
    const [email, setEmail] = React.useState('')
    const [password, setPassword] = React.useState('')
    const dispatch = useAppDispatch()
    const error = useAppSelector(state => state.users.error)
    const user = useAppSelector(state => state.users.currentUser)
    const navigate = useNavigate()
    const [cookies] = useCookies(['token'])
    const [loading, setLoading] = React.useState(false)

    useEffect(() => {
        console.log(error)
    }, [error]);

    useEffect(() => {
        if (user || cookies.token) {
            navigate('/')
        }
    }, [user, cookies]);

    useEffect(() => {
        dispatch(fetchUser())
    }, []);

    return (
        <div style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundImage: 'url(/images/back1.jpg)',
            width: '100%',
            height: '100%'
        }}>
            <Modal
                title=""
                open={true}
                centered={true}
                okButtonProps={{style: {display: 'none'}}}
                cancelButtonProps={{style: {display: 'none'}}}
                closable={false}
                mask={false}
                width={350}
            >
                <Flex vertical={true} gap={10} align={'center'}>
                    <Divider>
                        <img alt={'logo'} src={'/logo.svg'} style={{width: 32}}/>
                    </Divider>
                    <Flex style={{width: '100%'}} vertical={true} align={'center'}>
                        <div style={{width: '100%'}}><b>E-mail</b></div>
                        <Input type={'email'} value={email} onChange={(e) => setEmail(e.target.value)}/>
                    </Flex>
                    <Flex style={{width: '100%'}} vertical={true} align={'center'}>
                        <div style={{width: '100%'}}><b>Password</b></div>
                        <Password value={password} onChange={(e) => setPassword(e.target.value)}/>
                    </Flex>
                    <Flex style={{width: '100%', marginTop: 20}} vertical={true} align={'center'}>
                        <Button
                            style={{width: 200}}
                            type={'primary'}
                            disabled={email.length === 0 || password.length === 0}
                            loading={loading}
                            onClick={() => {
                                setLoading(true)
                                dispatch(signin({email: email, hash: md5(password)}))
                                    .finally(() => setLoading(false))
                            }
                            }
                        >Sign-in</Button>
                        <Divider>OR</Divider>
                        <Button style={{width: 200}} type={'text'}
                                onClick={() => navigate('/sign-up')}
                        >Create account</Button>
                    </Flex>
                </Flex>
            </Modal>
        </div>
    )
}